import './index.scss'

import React, { Children } from 'react'
import PropTypes from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('grid')

export default function Grid({
  children,
  grid,
  gutterless,
  gutter,
  align,
  valign,
  full,
  nodeType,
}) {
  const Node = nodeType

  const filteredChildren = Children.toArray(children).filter(
    (child) => child != null
  )

  return (
    <Node
      {...bem('', {
        [grid]: grid,
        'no-gutter': gutterless,
        full,
        gutter,
        [`align-${align}`]: align,
      })}
    >
      {filteredChildren.map((child, index) => (
        <div key={index} {...bem('item')}>
          {child}
        </div>
      ))}
    </Node>
  )
}

Grid.propTypes = {
  children: PropTypes.any.isRequired,
  grid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  nodeType: PropTypes.string,
  gutterless: PropTypes.bool,
  gutter: PropTypes.bool, 
  full: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'center', 'right', 'between']),
}

Grid.defaultProps = {
  nodeType: 'div',
  align: 'left',
  valign: 'top',
}
